module.exports = __webpack_public_path__ + "8f80078afc15181a99f50dd3d244f257.png";